import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  filtersWrapper: {
    display: 'flex',
  },
});

export default useStyles;
